import { render, staticRenderFns } from "./ClinicalResearchCategoriesSection.vue?vue&type=template&id=7a872957"
import script from "./ClinicalResearchCategoriesSection.vue?vue&type=script&lang=js"
export * from "./ClinicalResearchCategoriesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports